// @fileoverview : 경남-KPI > 제조리드타임(P) 화면 시연용 mock data
// 서버 응답(KPI.leadTime) row 형태와 동일한 구조로 작성한다.
// 실제 사용 여부는 pages/KPI/leadtime/index.tsx 의 USE_MOCK_DATA 로 결정한다.

export interface LeadTimeMockRow {
  productionPlanId: string;
  scheduledAt: string;
  itemCode: string;
  itemSpec: string;
  workerName: string;
  /** ISO8601 (KST offset) - 생산시작일시 */
  workStartTime: string;
  /** ISO8601 (KST offset) - 생산종료일시 */
  workEndTime: string;
  /** 제조리드타임 (시간) */
  leadTime: string;
  /** 생산량 (현재 테이블 컬럼에는 노출되지 않음) */
  productionQuantity: number;
}

/** 상단 요약 테이블에 표시할 품목 정보 */
export const LEADTIME_MOCK_ITEM = {
  code: "PP-REP60-MG",
  name: "PP REP60 Middle Gray",
  spec: "Middle Gray",
};

/**
 * 2026년 5~8월 PP REP60 Middle Gray 생산 LOT 13건.
 * 리드타임 합계 708hr, 평균 54.46hr/LOT.
 */
export const LEADTIME_MOCK_ROWS: LeadTimeMockRow[] = [
  {
    productionPlanId: "K1260618-1",
    scheduledAt: "2026-06-18T08:00:00+09:00",
    itemCode: LEADTIME_MOCK_ITEM.code,
    itemSpec: LEADTIME_MOCK_ITEM.spec,
    workerName: "김민수",
    workStartTime: "2026-06-18T08:00:00+09:00",
    workEndTime: "2026-06-20T04:00:00+09:00",
    leadTime: "44",
    productionQuantity: 20400,
  },
  {
    productionPlanId: "K1260617-1",
    scheduledAt: "2026-06-15T10:00:00+09:00",
    itemCode: LEADTIME_MOCK_ITEM.code,
    itemSpec: LEADTIME_MOCK_ITEM.spec,
    workerName: "이정훈",
    workStartTime: "2026-06-15T10:00:00+09:00",
    workEndTime: "2026-06-16T04:00:00+09:00",
    leadTime: "18",
    productionQuantity: 8000,
  },
  {
    productionPlanId: "K1260529-1",
    scheduledAt: "2026-06-03T09:00:00+09:00",
    itemCode: LEADTIME_MOCK_ITEM.code,
    itemSpec: LEADTIME_MOCK_ITEM.spec,
    workerName: "박서준",
    workStartTime: "2026-06-03T09:00:00+09:00",
    workEndTime: "2026-06-06T00:00:00+09:00",
    leadTime: "63",
    productionQuantity: 30000,
  },
  {
    productionPlanId: "K2260529-1",
    scheduledAt: "2026-06-03T12:00:00+09:00",
    itemCode: LEADTIME_MOCK_ITEM.code,
    itemSpec: LEADTIME_MOCK_ITEM.spec,
    workerName: "김민수",
    workStartTime: "2026-06-03T12:00:00+09:00",
    workEndTime: "2026-06-05T03:00:00+09:00",
    leadTime: "34",
    productionQuantity: 18000,
  },
  {
    productionPlanId: "K2260527-1",
    scheduledAt: "2026-05-27T06:00:00+09:00",
    itemCode: LEADTIME_MOCK_ITEM.code,
    itemSpec: LEADTIME_MOCK_ITEM.spec,
    workerName: "이정훈",
    workStartTime: "2026-05-27T06:00:00+09:00",
    workEndTime: "2026-05-29T11:00:00+09:00",
    leadTime: "29",
    productionQuantity: 24000,
  },
  {
    productionPlanId: "K2260702-1",
    scheduledAt: "2026-07-03T13:00:00+09:00",
    itemCode: LEADTIME_MOCK_ITEM.code,
    itemSpec: LEADTIME_MOCK_ITEM.spec,
    workerName: "박서준",
    workStartTime: "2026-07-03T13:00:00+09:00",
    workEndTime: "2026-07-07T14:00:00+09:00",
    leadTime: "49",
    productionQuantity: 22800,
  },
  {
    productionPlanId: "K1260701-1",
    scheduledAt: "2026-07-01T08:00:00+09:00",
    itemCode: LEADTIME_MOCK_ITEM.code,
    itemSpec: LEADTIME_MOCK_ITEM.spec,
    workerName: "김민수",
    workStartTime: "2026-07-01T08:00:00+09:00",
    workEndTime: "2026-07-06T12:00:00+09:00",
    leadTime: "76",
    productionQuantity: 36000,
  },
  {
    productionPlanId: "K2260604-1",
    scheduledAt: "2026-06-08T10:00:00+09:00",
    itemCode: LEADTIME_MOCK_ITEM.code,
    itemSpec: LEADTIME_MOCK_ITEM.spec,
    workerName: "이정훈",
    workStartTime: "2026-06-08T10:00:00+09:00",
    workEndTime: "2026-06-11T14:00:00+09:00",
    leadTime: "76",
    productionQuantity: 36000,
  },
  {
    productionPlanId: "K1260526-1",
    scheduledAt: "2026-05-25T09:00:00+09:00",
    itemCode: LEADTIME_MOCK_ITEM.code,
    itemSpec: LEADTIME_MOCK_ITEM.spec,
    workerName: "박서준",
    workStartTime: "2026-05-25T09:00:00+09:00",
    workEndTime: "2026-05-28T13:00:00+09:00",
    leadTime: "76",
    productionQuantity: 36000,
  },
  {
    productionPlanId: "K1260527-1",
    scheduledAt: "2026-05-27T10:00:00+09:00",
    itemCode: LEADTIME_MOCK_ITEM.code,
    itemSpec: LEADTIME_MOCK_ITEM.spec,
    workerName: "김민수",
    workStartTime: "2026-05-27T10:00:00+09:00",
    workEndTime: "2026-06-01T14:00:00+09:00",
    leadTime: "76",
    productionQuantity: 36000,
  },
  {
    productionPlanId: "K2260714-1",
    scheduledAt: "2026-07-14T08:00:00+09:00",
    itemCode: LEADTIME_MOCK_ITEM.code,
    itemSpec: LEADTIME_MOCK_ITEM.spec,
    workerName: "이정훈",
    workStartTime: "2026-07-14T08:00:00+09:00",
    workEndTime: "2026-07-16T00:00:00+09:00",
    leadTime: "64",
    productionQuantity: 30000,
  },
  {
    productionPlanId: "K2260717-1",
    scheduledAt: "2026-07-17T21:00:00+09:00",
    itemCode: LEADTIME_MOCK_ITEM.code,
    itemSpec: LEADTIME_MOCK_ITEM.spec,
    workerName: "박서준",
    workStartTime: "2026-07-17T21:00:00+09:00",
    workEndTime: "2026-07-20T23:00:00+09:00",
    leadTime: "39",
    productionQuantity: 18000,
  },
  {
    productionPlanId: "K2260723-1",
    scheduledAt: "2026-07-23T10:00:00+09:00",
    itemCode: LEADTIME_MOCK_ITEM.code,
    itemSpec: LEADTIME_MOCK_ITEM.spec,
    workerName: "김민수",
    workStartTime: "2026-07-23T10:00:00+09:00",
    workEndTime: "2026-07-28T14:00:00+09:00",
    leadTime: "64",
    productionQuantity: 30000,
  },
];
